
import React from 'react'
import {Navbar, Nav, Image} from 'react-bootstrap'

import { useAuth } from "../contexts/FirebaseAuth"

import "./TopNav.css"

export default function TopNav() {
    const { currentUser } = useAuth()
    //const [expanded, setExpanded] = useState(false)

    return (
        <Navbar bg="light" // controls nav background color
            // fixed="top" // keeps nav at top (not necessary when sticky top is set)
            sticky="top" // pushes page below, prevents overlap when expanded
            expand="sm" // collapse when less wide than this breakpoint
            collapseOnSelect // collapse after a nav link has been clicked
            style={{marginBottom:"0", borderBottom: "3px solid darkgray", fontSize: "1.25rem"}}
            className="px-3"

            // OVERRIDING DEFAULT BEHAVIOR SO WE CAN DETECT CURRENT TOGGLED STATE
            //expanded={expanded}
            //onToggle={next => setExpanded(next)}

        >
            <Navbar.Brand href="/" style={{fontSize:22}}>
                <img src="/favicon-96x96.png" style={{ maxHeight: '35px' }} alt="qry fox"></img>
                <span style={{fontWeight: 'bold'}}>qry</span>sign
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">
                    <Nav.Link href="/">Home</Nav.Link>
                    <Nav.Link href="/about">About</Nav.Link>
                    <Nav.Link href="/how-to">How To</Nav.Link>
                    {/* <Nav.Link href="/products">Products</Nav.Link>
                    {!currentUser &&
                        <Nav.Link href="/login">Login</Nav.Link>
                    } */}
                </Nav>

               { currentUser &&
                    <Nav.Link href="/profile" className="profile-link">
                        <Image roundedCircle src={currentUser.photoURL} alt="user profile" height="35px"/>
                    </Nav.Link>
                }

            </Navbar.Collapse>
        </Navbar>
    )
}
